import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'shared-quick-selector',
    templateUrl: './quick-selector.shared.component.html',
    styleUrls: ['./quick-selector.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuickSelectorComponent implements OnInit {
    private _isOpen: boolean = false;
    @Input() public defaultLabel: string = 'select';
    @Input() public selected: OLO.Components.DropDown.IDropDownOption;
    @Input() public options: OLO.Components.DropDown.IDropDownOption[];

    @Output() public onSelected: EventEmitter<OLO.Components.DropDown.IDropDownOption> = new EventEmitter();
    @Output() public onToggle: EventEmitter<boolean> = new EventEmitter();

    @Input() public theme: OLO.Components.DropDown.IDropDownTheme = 'light'; /* Consumer -> shared-dropdown */
    @Input() public size: OLO.Components.DropDown.IDropDownSize = 'md'; /* Consumer -> shared-dropdown */
    @Input() public position: OLO.Components.DropDown.IDropDownPosition = 'tl'; /* Consumer -> shared-dropdown */
    @Input() public projection: 'local' | 'global' = 'local'; /* Consumer -> shared-dropdown */
    @Input() public projectionStyle: { [key: string]: number | string } = null; /* Consumer -> shared-dropdown */

    constructor(
        public changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void { }

    public onDropdownToggle(isOpen: boolean): void {
        this._isOpen = isOpen;
        this.onToggle.emit(this._isOpen);
        this.changeDetectorRef.detectChanges();
    }

    public onDropdownSelected($event: OLO.Components.DropDown.IDropDownOption): void {
        this.onSelected.emit($event);
        this.changeDetectorRef.detectChanges();
    }
}
